import React, { useState } from 'react';
import { Alert, Button, Card, Form, Stack } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useCreateNewsCommentMutation } from '../slices/newsApiSlice';

const NewsComments = ({ post }) => {
  const { userInfo } = useSelector((state) => state.auth);
  const [body, setBody] = useState('');
  const [createComment, { isLoading }] = useCreateNewsCommentMutation();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!body.trim()) {
      toast.error('Write a comment before posting.');
      return;
    }

    try {
      await createComment({ postId: post._id, body: body.trim() }).unwrap();
      setBody('');
      toast.success('Comment posted.');
    } catch (error) {
      toast.error(error?.data?.message || 'Failed to post comment');
    }
  };

  return (
    <section className="mt-5">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h3 className="mb-0">Questions & Comments</h3>
        <span className="text-secondary small">{post.comments?.length || 0} visible</span>
      </div>

      {userInfo ? (
        post.lockedComments ? (
          <Alert variant="secondary">Comments are locked for this update.</Alert>
        ) : (
          <Card className="modern-card mb-4">
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="news-comment-body">
                  <Form.Label>Join the conversation</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={body}
                    onChange={(event) => setBody(event.target.value)}
                    placeholder="Ask a question or leave feedback for the team."
                    maxLength={2000}
                  />
                </Form.Group>
                <Button type="submit" disabled={isLoading}>
                  {isLoading ? 'Posting...' : 'Post Comment'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        )
      ) : (
        <Alert variant="info">Sign in to ask questions or leave feedback on updates.</Alert>
      )}

      <Stack gap={3}>
        {post.comments?.length ? (
          post.comments.map((comment) => (
            <Card key={comment._id} className="modern-card">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start gap-3 mb-2">
                  <div>
                    <strong>{comment.user?.username || 'League Runner user'}</strong>
                    <div className="text-secondary small">
                      {new Date(comment.createdAt).toLocaleString()}
                      {comment.editedAt ? ' · edited' : ''}
                    </div>
                  </div>
                </div>
                <div style={{ whiteSpace: 'pre-wrap' }}>{comment.body}</div>
              </Card.Body>
            </Card>
          ))
        ) : (
          <Card className="modern-card">
            <Card.Body className="text-secondary">
              No comments yet. The first question can set the tone for the whole thread.
            </Card.Body>
          </Card>
        )}
      </Stack>
    </section>
  );
};

export default NewsComments;
